import {TProductCategory } from './../model.d';
import { TIndexState, TUpsertISRProjectDataModelsInput } from "../model";

type useCategoryConfigurationUpdaterProps = {
  setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
}

const useCategoryConfigurationUpdater = ({ setUserProjectDataModels }: useCategoryConfigurationUpdaterProps) => {

  const updateCategoryConfiguration = (indexInfo: TIndexState, updatedConfig: TProductCategory, belongsToDataModel: boolean) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      if (belongsToDataModel) {
        // Update in the dataModels
        const dataModelToUpdate = newDataModels.project.dataModels[indexInfo.dataModelIndex ?? -1];
        if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1]) {
          dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1] = updatedConfig;
        }
      } else {
        // Update in the fields array
        const fieldToUpdate = newDataModels.project.productCategories[indexInfo.categoryOutsideDataModelIndex ?? -1];
        if (fieldToUpdate) {
          fieldToUpdate.type = updatedConfig.type;
          fieldToUpdate.data = updatedConfig.data;
        }
      }
      return newDataModels;
    });
  };
  

  return { updateCategoryConfiguration };
};

export default useCategoryConfigurationUpdater;